var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599976 2.00005C0.599976 1.68179 0.726404 1.37656 0.951447 1.15152C1.17649 0.926477 1.48172 0.800049 1.79998 0.800049H16.2C16.5182 0.800049 16.8235 0.926477 17.0485 1.15152C17.2736 1.37656 17.4 1.68179 17.4 2.00005C17.4 2.31831 17.2736 2.62353 17.0485 2.84858C16.8235 3.07362 16.5182 3.20005 16.2 3.20005H1.79998C1.48172 3.20005 1.17649 3.07362 0.951447 2.84858C0.726404 2.62353 0.599976 2.31831 0.599976 2.00005ZM0.599976 8.00005C0.599976 7.68179 0.726404 7.37657 0.951447 7.15152C1.17649 6.92648 1.48172 6.80005 1.79998 6.80005H16.2C16.5182 6.80005 16.8235 6.92648 17.0485 7.15152C17.2736 7.37657 17.4 7.68179 17.4 8.00005C17.4 8.31831 17.2736 8.62353 17.0485 8.84858C16.8235 9.07362 16.5182 9.20005 16.2 9.20005H1.79998C1.48172 9.20005 1.17649 9.07362 0.951447 8.84858C0.726404 8.62353 0.599976 8.31831 0.599976 8.00005ZM0.599976 14.0001C0.599976 13.6818 0.726404 13.3766 0.951447 13.1515C1.17649 12.9265 1.48172 12.8001 1.79998 12.8001H8.99998C9.31824 12.8001 9.62346 12.9265 9.84851 13.1515C10.0735 13.3766 10.2 13.6818 10.2 14.0001C10.2 14.3183 10.0735 14.6235 9.84851 14.8486C9.62346 15.0736 9.31824 15.2001 8.99998 15.2001H1.79998C1.48172 15.2001 1.17649 15.0736 0.951447 14.8486C0.726404 14.6235 0.599976 14.3183 0.599976 14.0001Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.79b6558d67c7c6ef49fbf6e6c00b6996.svg";
export { ForwardRef as ReactComponent };